import WidgetsList from './WidgetList';
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import CreateWidget from './WidgetCreate';
import EditWidget from './WidgetEdit';
import ViewWidget from './WidgetVIew';

export default {
  list: WidgetsList,
  create: CreateWidget,
  edit: EditWidget,
  show: ViewWidget,
  icon: EmojiPeopleIcon,
};
